import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: 800,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  initialContainer: {
    width: 800,
    backgroundColor: '#0E1444',
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24,
    padding: '24px 0',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  initialText: {
    fontFamily: 'Poppins',
    fontSize: 18,
    fontWeight: 600,
    color: '#FAFAFA',
    textAlign: 'center',
    lineHeight: 1.4,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },

  generateButton: {
    backgroundColor: '#FFFFFF',
    color: '#000A8C',
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    padding: '8px 20px',
    borderRadius: 4,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#F5F5F5',
      boxShadow: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
      padding: '7px 16px',
    },
  },

  loadingContainer: {
    width: 800,
    height: 132,
    backgroundColor: '#0E1444',
    borderRadius: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  loadingText: {
    fontFamily: 'Poppins',
    fontSize: 16,
    fontWeight: 600,
    color: '#FAFAFA',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },

  header: {
    height: 92,
    backgroundColor: '#0E1444',
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
      height: 80,
      margin: 20,
      marginBottom: 0,
    },
  },

  headerText: {
    fontFamily: 'Poppins',
    fontSize: 20,
    fontWeight: 700,
    color: '#FAFAFA',
    textAlign: 'center',
    lineHeight: 1.3,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },

  contentBlock: {
    width: 800,
    backgroundColor: '#FFFFFF',
    borderRadius: 3,
    position: 'relative',
    border: '1px solid transparent',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  contentText: {
    fontFamily: 'Poppins',
    fontSize: 16,
    fontWeight: 400,
    color: '#0E1247',
    lineHeight: 1.6,
    margin: 20,
    [theme.breakpoints.down('sm')]: {
      margin: 20,
    },
    '& p': {
      margin: '0 0 16px 0',
      fontFamily: 'Poppins !important',
      color: '#0E1247 !important',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    '& strong': {
      fontWeight: 600,
      color: '#0E1247 !important',
      fontFamily: 'Poppins !important',
    },
    '& a': {
      color: '#000A8C !important',
      textDecoration: 'underline',
      fontFamily: 'Poppins !important',
    },
    '& ul, & ol': {
      marginLeft: 20,
      marginBottom: 16,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    '& li': {
      marginBottom: 8,
      color: '#0E1247 !important',
      fontFamily: 'Poppins !important',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    '& h1': {
      fontSize: 20,
    },
    '& h2': {
      fontSize: 18,
    },
    '& h3 & h4 & h5 & h6': {
      fontSize: 16,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },

  fadeOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 100,
    background: 'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.95), #fff)',
    pointerEvents: 'none',
    borderRadius: 3,
  },

  showMoreButton: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: -20,
    zIndex: 2,
    backgroundColor: '#fff',
    color: '#18181B',
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    border: '1.5px solid #000A8C',
    whiteSpace: 'nowrap',
    padding: '8px 16px',
    minWidth: 'auto',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: '#F7F7FB',
      border: '1.5px solid #000A8C',
    },
    [theme.breakpoints.down('sm')]: {
      bottom: -20,
      fontSize: 13,
      padding: '7px 14px',
    },
  },

  seeLessButton: {
    color: '#001858',
    textDecoration: 'underline',
    textTransform: 'none',
    fontWeight: 600,
    fontFamily: 'Poppins',
    fontSize: 14,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    padding: '8px 0',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
}));
